import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import {
  defaultShouldDehydrateMutation,
  defaultShouldDehydrateQuery,
  type Mutation,
  type Query,
} from '@tanstack/react-query'
import { get as getItem, del as removeItem, set as setItem } from 'idb-keyval'
import {
  conversationQueryKeys,
  getSettingsQueryKeys,
  integrationCredentialMutationKeys,
} from 'v2/shared/utils/query-key-management'

export const idbPersister = createAsyncStoragePersister({
  storage: { getItem, setItem, removeItem },
})

const NEVER_PERSISTED = new Set<unknown>([
  conversationQueryKeys().crmContactBase[0],
  integrationCredentialMutationKeys().base[0],
  getSettingsQueryKeys().indiaKycBase[0],
])

// CRM contact details are third-party PII and India KYC is the customer's identity (name,
// address, masked PAN and Aadhaar): neither may outlive the tab in IndexedDB.
export const shouldPersistQuery = (query: Query) =>
  defaultShouldDehydrateQuery(query) && !NEVER_PERSISTED.has(query.queryKey[0])

// A mutation submitted offline is paused and dehydrates with its variables: a Test lookup's phone,
// an integration's tokens and client secrets, or a KYC step's PAN.
export const shouldPersistMutation = (mutation: Mutation) =>
  defaultShouldDehydrateMutation(mutation) &&
  !NEVER_PERSISTED.has(mutation.options.mutationKey?.[0])
